import { z } from 'zod';
import { StatusTypeSchema } from '../enums/status.js';

export const promptMessageSchema = z.object({
  role: z.enum(['system', 'user']),
  content: z.string(),
});
export type PromptMessage = z.infer<typeof promptMessageSchema>;

export const promptListItemSchema = z.object({
  id: z.number(),
  identifier: z.string().uuid(),
  name: z.string(),
  description: z.string(),
  status: StatusTypeSchema,
  version: z.number(),
  createdOn: z.coerce.date(),
});
export type PromptListItem = z.infer<typeof promptListItemSchema>;

export const promptDetailsSchema = z.object({
  id: z.number(),
  identifier: z.string().uuid(),
  name: z.string(),
  description: z.string(),
  status: StatusTypeSchema,
  version: z.number(),
  messages: z.array(promptMessageSchema),
  inputSchema: z.record(z.string(), z.unknown()),
  isActive: z.boolean(),
  createdOn: z.coerce.date(),
});
export type PromptDetails = z.infer<typeof promptDetailsSchema>;
